import { render, staticRenderFns } from "./commonTabSlider.vue?vue&type=template&id=41995578&scoped=true"
import script from "./commonTabSlider.vue?vue&type=script&lang=js"
export * from "./commonTabSlider.vue?vue&type=script&lang=js"
import style0 from "./commonTabSlider.vue?vue&type=style&index=0&id=41995578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41995578",
  null
  
)

export default component.exports